import firebase, { database } from 'firebase/app'
import 'firebase/firestore'
import 'firebase/database'
import _ from 'lodash'
import format from 'date-fns/format'
import parse from 'date-fns/parse'
import { globalfunc } from '../globalfunc.js'
import axios from 'axios'

const apiUrl = process.env.VUE_APP_API_URL

const ucfirst = (string: string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
const isEmptyObject = (value: object) => {
  return Object.keys(value).length === 0
}

export default {
  namespaced: true,
  state: {
    selectedSso: {},
    dataSettings: { 'webhook_logs': [] },
    directorySyncSettings: {},
    hasDirectorySyncSettings: false,
    apiKeys: {},
    apiKeyDev: {},
    apiKeyProd: {},
    apiLogs: { page: 1, data: [], results: [], error: false, errorMsg: '' },
    resultsSimulate: [],
    membersSimulate: [],
    membersSimulateAll: [],
    loadingSimulateTable: true,
    inputSearchSimulate: '',
    size_page: 10,
    sortfieldsimulate: 'value',
    sortordersimulate: 'asc',
    pagesimulate: 1,
    resultsView: [],
    membersView: [],
    membersViewAll: [],
    loadingViewTable: true,
    inputSearchView: '',
    sortfieldview: 'value',
    sortorderview: 'asc',
    pageview: 1,
    tokenLength: 30,

    reviewUpdates: [],
    reviewUpdatesAll: [],
    reviewUpdatesTotal: 0,
    reviewUpdatesPage: 1,
    reviewUpdatesByKey: [],
    pageReviewUpdates: 1,
    sortfieldreviewupdates: 'email',
    sortordereviewupdates: 'asc',
    reviewUpdatesLoading: false,
    _reviewUpdates: [],
    _reviewUpdatesAll: [],
    reviewUpdatesIgnorePendingStatus: false, // true for dev mode
  },
  mutations: {
    selectedSso(state: any, result: object) {
      state.selectedSso = result
    },
    setApiKeys(state: any, result: any) {
      state.apiKeys = result
    },
    setApiKeyDev(state: any, result: any) {
      state.apiKeyDev = result
    },
    setApiKeyProd(state: any, result: any) {
      state.apiKeyProd = result
    },
    unsetApiKeyDev(state: any, result: any) {
      const apiKeyDev = {
        generate: false,
        token: '',
        mockTaken: [],
        showingStatus: false,
      }
      state.apiKeyDev = apiKeyDev;
    },
    unsetApiKeyProd(state: any, result: any) {
      const apiKeyProd = {
        generate: false,
        token: '',
        mockTaken: [],
        showingStatus: false,
      }
      state.apiKeyProd = apiKeyProd;
    },
    setApiLogs(state: any, result: any) {
      state.apiLogs = result
    },
    setDataIntegrationSettings(state: any, result: any) {
      state.dataSettings = result
    },
    setHasDirectorySyncSettings(state: any, result: any) {
      state.hasDirectorySyncSettings = result
    },
    setDirectorySyncSettings(state: any, result: any) {
      state.directorySyncSettings = result
    },
    settokenTemp(state: any) {
      state.dataSettings.token_temp = globalfunc.generateToken(state.tokenLength)
    },
    setResultsSimulate(state: any, result: any) {
      state.resultsSimulate = result
    },
    setMemberSimulate(state: any, value: any) {
      state.membersSimulate = value
    },
    setMemberSimulateAll(state: any, value: any) {
      state.membersSimulateAll = value
    },
    setLoadingSimulateTable(state: any, result: any) {
      state.loadingSimulateTable = result
    },
    setinputSearchSimulate(state: any, value: any) {
      state.inputSearchSimulate = value.keyword
    },
    setPageSimulate(state: any, result: any) {
      state.pagesimulate = result
    },
    setSortfieldSimulate(state: any, result: any) {
      state.sortfieldsimulate = result
    },
    setSortorderSimulate(state: any, result: any) {
      state.sortordersimulate = result
    },
    setResultsView(state: any, result: any) {
      state.resultsView = result
    },
    setMemberView(state: any, value: any) {
      state.membersView = value
    },
    setMemberViewAll(state: any, value: any) {
      state.membersViewAll = value
    },
    setLoadingViewTable(state: any, result: any) {
      state.loadingViewTable = result
    },
    setinputSearchView(state: any, value: any) {
      state.inputSearchView = value.keyword
    },
    setPageView(state: any, result: any) {
      state.pageview = result
    },
    setSortfieldView(state: any, result: any) {
      state.sortfieldview = result
    },
    setSortorderView(state: any, result: any) {
      state.sortorderview = result
    },
    setReviewUpdates(state: any, result: any) {
      state.reviewUpdates = result
    },
    setReviewUpdatesAll(state: any, result: any) {
      state.reviewUpdatesAll = result
    },
    setReviewUpdatesLoading(state: any, result: any) {
      state.reviewUpdatesLoading = result
    },
    setReviewUpdatesTotal(state: any, result: any) {
      state.reviewUpdatesTotal = result
    },
    reviewUpdatesPage(state: any, result: any) {
      state.reviewUpdatesPage = result
    },
    setReviewUpdatesByKey(state: any, result: any) {
      state.reviewUpdatesByKey = result
    },
    setPageReviewUpdates(state: any, result: any) {
      state.pageReviewUpdates = result
    },
    setSortfieldReviewUpdates(state:any,result:any) {
      state.sortfieldreviewupdates = result
    },
    setSortorderReviewUpdates(state:any,result:any) {
      state.reviewupdates = result
    },
  },
  actions: {

    async getUserCompany({ commit, rootState, dispatch, state }: any) {
      return (await firebase.database().ref(`company/${rootState.authen.user.company}`).once('value')).val()
    },

    /* sso */

    // _createSsoBySaml()

    // used for unauthenticated story
    async getSelectedSsoByEmail({ commit, rootState, dispatch, state }: any, email: string) {
      let user;
      if(email){
        const emailKey = email.replace(/\./g, '||')
        if (rootState.main.allUser[emailKey]) {
          user = rootState.main.allUser[emailKey];
        } else {
          user = (await firebase.database().ref(`/users/${emailKey}`).once('value')).val();
        }
      }
      let selectedSso = null
      if (user) {
        const company = (await firebase.database().ref(`company/${user.company}`).once('value')).val();
        const sso_configuration = company.sso_configuration || {};
        const options = sso_configuration.options || [];
        selectedSso = _.find(options, ['selected', true]);
      }
      return selectedSso
    },

    async createDefaultSsoConfiguration({ commit, rootState, dispatch, state }: any, values: object) {
      const sso_configuration = Object.assign({
        enabled: false,
        options: []
      }, values)

      await firebase.database().ref(`company/${rootState.authen.user.company}`).update({
        "sso_configuration": sso_configuration,
        "updated": format(new Date(), "YYYY-MM-DD HH:mm:ss")
      })

      return sso_configuration
    },

    async getSsoConfiguration({ commit, rootState, dispatch, state }: any) {
      let company = await dispatch('getUserCompany')
      let sso_configuration = company.sso_configuration || {}
      if (isEmptyObject(sso_configuration)) {
        sso_configuration = await dispatch('createDefaultSsoConfiguration', { enabled: true })
      }
      return sso_configuration
    },

    async saveSso({ commit, rootState, dispatch, state }: any, selectedSso: any) {
      let sso_configuration = await dispatch('getSsoConfiguration')
      if (!sso_configuration.options) sso_configuration.options = []

      let found = false
      for (let i in sso_configuration.options) {
        sso_configuration.options[i].selected = false
        if (sso_configuration.options[i].ssoProviderId == selectedSso.ssoProviderId) {
          sso_configuration.options[i] = selectedSso
          found = true
        }
      }

      if (!found) {
        sso_configuration.options.push(selectedSso)
      }

      // Create or Update (Inconsistency 2 way apis)
      // console.log(found, 'found')
      if (found) {

        const asyncFunction = (resolve, reject) => {
          axios.put(`${apiUrl}/identity-platform/update-config-provider/${selectedSso.ssoProviderId}`, {
            "displayName": selectedSso.connectionName,
            "enabled": selectedSso.enabled,
            "idpEntityId": selectedSso.idpEntityId,
            "ssoURL": selectedSso.ssoUrl,
            "x509Certificates": [selectedSso.certificate],
            "rpEntityId": selectedSso.spEntityId,
            "callbackURL": selectedSso.acsUrl
          })
            .then(function (response) {
              // console.log(response, 'response');
              resolve(response)
            })
            .catch(function (error) {
              // console.log(error, 'error');
              reject(error)
            });
        }

        const fn = new Promise((resolve, reject) => {
          asyncFunction(resolve, reject)
        })

        await fn;

      } else {

        const asyncFunction = (resolve, reject) => {
          axios.post(`${apiUrl}/identity-platform/create-config-provider`, {
            "displayName": selectedSso.connectionName,
            "enabled": selectedSso.enabled,
            "providerId": selectedSso.ssoProviderId,
            "idpEntityId": selectedSso.idpEntityId,
            "ssoURL": selectedSso.ssoUrl,
            "x509Certificates": [selectedSso.certificate],
            "rpEntityId": selectedSso.spEntityId,
            "callbackURL": selectedSso.acsUrl
          })
            .then(function (response) {
              // console.log(response, 'response');
              resolve(response)
            })
            .catch(function (error) {
              // console.log(error, 'error');
              reject(error)
            });
        }

        const fn = new Promise((resolve, reject) => {
          asyncFunction(resolve, reject)
        })

        await fn;
      }


      // @TODO update only option
      await firebase.database().ref(`company/${rootState.authen.user.company}`).update({
        "sso_configuration": sso_configuration,
        "updated": format(new Date(), "YYYY-MM-DD HH:mm:ss")
      })
    },

    async deleteSso({ commit, rootState, dispatch, state }: any, selectedSso: any) {
      let sso_configuration = await dispatch('getSsoConfiguration')
      if (!sso_configuration.options) sso_configuration.options = []

      let found = false
      let index = ''
      for (let i in sso_configuration.options) {
        if (sso_configuration.options[i].ssoProviderId == selectedSso.ssoProviderId) {
          sso_configuration.options[i] = selectedSso
          found = true
          index = i
        }
      }

      if (found) {
        const ssoProviderId = sso_configuration.options[index].ssoProviderId
        delete sso_configuration.options[index]

        const asyncFunction = (resolve, reject) => {
          axios.delete(`${apiUrl}/identity-platform/delete-config-provider/${ssoProviderId}`)
            .then(function (response) {
              // console.log(response, 'response');
              resolve(response)
            })
            .catch(function (error) {
              // console.log(error, 'error');
              reject(error)
            });
        }

        const fn = new Promise((resolve, reject) => {
          asyncFunction(resolve, reject)
        })

        await fn;
      }

      // @TODO update only option
      await firebase.database().ref(`company/${rootState.authen.user.company}`).update({
        "sso_configuration": sso_configuration,
        "updated": format(new Date(), "YYYY-MM-DD HH:mm:ss")
      })
    },

    /* api key */

    async getApiKeys({ commit, rootState, dispatch, state }: any) {
      // @todo use common function
      let company = (await firebase.database().ref(`company/${rootState.authen.user.company}`).once('value')).val()
      const emptyApiKeyObj = {
        generate: false,
        token: "",
        mockTaken: new Array,
        showingStatus: false,
      }
      let apiKeys = company.api_keys || {};

      const auto_create_api_key_dev = company.auto_create_api_key_dev || false;

      let apiKeyDev = Object.assign({}, emptyApiKeyObj);
      let apiKeyProd = Object.assign({}, emptyApiKeyObj);

      const assignApiKeyValue = (targetObj, valueObj) => {
        if (valueObj) {
          targetObj.generate = true;
          targetObj.token = valueObj.api_key;

          let token = new Array;
          for (let i: number = 0; i < targetObj.token.length; i++) {
            token.push(i);
          }
          targetObj.mockTaken = token;
        }
      }

      if (!auto_create_api_key_dev && !apiKeys.dev) {
        await dispatch('createApiKey', 'dev');

        // reload new data for company and apiKeys
        company = (await firebase.database().ref(`company/${rootState.authen.user.company}`).once('value')).val()
        apiKeys = company.api_keys || {};

        // @todo update company flags
        await firebase.database().ref(`company/${rootState.authen.user.company}`).update({
          "auto_create_api_key_dev": true,
          "updated": format(new Date(), "YYYY-MM-DD HH:mm:ss")
        })
      }

      if (apiKeys.dev) {
        assignApiKeyValue(apiKeyDev, apiKeys.dev);
      }

      if (apiKeys.prod) {
        assignApiKeyValue(apiKeyProd, apiKeys.prod);
      }

      commit('setApiKeys', apiKeys)
      commit('setApiKeyDev', apiKeyDev);
      commit('setApiKeyProd', apiKeyProd);
    },

    async createApiKey({ commit, rootState, dispatch, state }: any, stageName: string) {
      const asyncFunction = (resolve) => {
        // console.log(stageName, 'stageName');
        axios.post(`${apiUrl}/apigateway/create-api-key`, {
          "companyId": rootState.authen.user.company,
          "usagePlanId": "3shwv6",
          "restApiId": "ln1buvf68h",
          "stageName": stageName
        })
          .then(function (response) {
            // console.log(response, 'response');
            const data = response.data;
            if (data.statusCode != 500) {
              const apiKeyObj = {
                generate: true,
                token: data.value,
                mockTaken: [],
                showingStatus: false,
              }
              commit(`setApiKey${ucfirst(stageName)}`, apiKeyObj);
              resolve(apiKeyObj);
            }
          })
          .catch(function (error) {
            console.log(error, 'error');
          });
      }

      const fn = new Promise((resolve, reject) => {
        asyncFunction(resolve)
      })

      await fn;
    },

    async removeApiKey({ commit, rootState, dispatch, state }: any, stageName: string) {
      const company = (await firebase.database().ref(`company/${rootState.authen.user.company}`).once('value')).val()
      try {
        const apiKey = company.api_keys[stageName].api_key
        const asyncFunction = (resolve) => {
          axios.post(`${apiUrl}/apigateway/delete-api-key`, {
            "apiKey": apiKey
          })
            .then(function (response) {
              commit(`unsetApiKey${ucfirst(stageName)}`)
              resolve();
            })
            .catch(function (error) {
              console.log(error, 'error');
              resolve();
            })
        }
        const fn = new Promise((resolve, reject) => {
          asyncFunction(resolve)
        })
        await fn;
      } catch (e) {
        console.log(e);
      }
    },

    async getApiLogs({ commit, rootState, dispatch, state }: any) {
      let results: any = { page: 1, data: [], results: [] };

      const companyId = rootState.authen.user.company;

      let dateNow = new Date();
      dateNow.setHours(dateNow.getHours() + 7);
      let endDate = dateNow.getTime();

      let diffDay: number;
      diffDay = dateNow.getDate() - 7;
      dateNow.setDate(diffDay);

      let startDate = dateNow.getTime();

      // @see https://docs.aws.amazon.com/AWSJavaScriptSDK/latest/AWS/CloudWatchLogs.html#filterLogEvents-property
      axios.post(`${apiUrl}/logs/filter-log-events`, {
        "logGroupName": process.env.VUE_APP_API_LOG_GROUP,
        "endTime": endDate,
        //"limit": 10000,
        "logStreamNamePrefix": companyId + "||",
        "startTime": startDate
        //"interleaved": true
      })
        .then(function (response) {
          try {
            const events = response.data.events || [];

            const monthNames = ["January", "February", "March", "April", "May", "June",
              "July", "August", "September", "October", "November", "December"
            ];

            const langMapping = {
              "dev": "Developement",
              "prod": "Production",
              "getMedalById": "Happily Medal: Get Medal",
              "getRecognitionsForMember": "Happily Recognition - Get Recognitions for Member",
              "createRecognition": "Happily Recognition - Create Recognition"
            }

            const pad = (num, size) => {
                var s = "00" + num;
                return s.substring(s.length-size);
            }

            events.forEach(event => {
              const rawData = JSON.parse(event.message);

              // @fixed 13 digits timestamp with milliseconds value
              const date = new Date(event.ingestionTime);
              const YYYY = date.getFullYear();
              const MMMM = monthNames[date.getMonth()];
              const d = date.getDate();
              const h = ("0" + (date.getHours() >= 12 ? (date.getHours() - 12) : date.getHours())).slice(-2);
              const mm = pad(date.getMinutes(), 2);
              const A = date.getHours() >= 12 ? "PM" : "AM";

              const displayedDate = `${MMMM} ${d}, ${YYYY}`
              const displayedTime = `${h}:${mm} ${A}`

              const data = {
                // date: format(parse(event.ingestionTime),'MMMM d, YYYY'),
                // time: format(parse(event.ingestionTime),'h:mm A'),
                eventId: event.eventId,
                logStreamName: event.logStreamName,
                timestamp: event.timestamp,
                date: displayedDate,
                time: displayedTime,
                operation: langMapping[rawData.operation],
                status: rawData.status ? 'Success' : 'Failed',
                deployment: langMapping[rawData.deployment]
              };

              results.data.push(data)
            });

            commit('setApiLogs', results)
            dispatch('pageCurrentLogChange', 1)
          } catch (e) {
            console.log(e, 'e');
          }
        })
        .catch(function (error) {
          console.log(error, 'error');
          const apiLogs = { page: 1, data: [], results: [], error: true, errorMsg: error.message }
          commit('setApiLogs', apiLogs)
        });

    },

    pageCurrentLogChange({ commit, rootState, dispatch, state }: any, value: number) {
      let sizePage = 10;
      let start_row = (value - 1) * sizePage
      let end_row = ((value - 1) * sizePage) + sizePage

      state.apiLogs.page = value;
      state.apiLogs.results = state.apiLogs.data.slice(start_row, end_row)
      commit('setApiLogs', state.apiLogs)
    },

    async getDataIntregrationSetting({ commit, rootState, dispatch, state }: any, user: any) {
      let results: any
      let dateNow = new Date()

      await firebase.database().ref(`integration_settings/${rootState.authen.user.company}`).once('value', (snapshot) => {
        if (snapshot.val()) {
          results = snapshot.val()
        } else {
          let objData = {
            webhook: 'https://integrations-bv43tjyzrq-de.a.run.app/users',
            token: globalfunc.generateToken(state.tokenLength),
            sync_type: 'normal',
            live: false,
            abbreviate_team_name: false,
            updated: format(dateNow, 'YYYY-MM-DD HH:mm'),
            created: format(dateNow, 'YYYY-MM-DD HH:mm'),

          }
          firebase.database().ref(`/integration_settings`).child(rootState.authen.user.company).set(objData)
          results = objData
        }
      });
      results.webhook_logs = new Array()
      await firebase.database().ref('integration_request_logs')
        .orderByChild('comp_id')
        .equalTo(rootState.authen.user.company)
        .once('value', snapshot => {
          snapshot.forEach((doc): any => {
            let data = doc.val()
            data.parse_date = format(parse(data.batch_ct), 'MMMM d, YYYY')
            data.parse_time = format(parse(data.batch_ct), 'h:mm A')
            data.content = JSON.stringify(data.request_data)
            results.webhook_logs.push(data)
          });
        });

      results.token_temp = results.token
      // json_encode
      commit('setDataIntegrationSettings', results)

      // @todo connect realtime database
      commit('setHasDirectorySyncSettings', false);
      commit('setDirectorySyncSettings', {
        'endpoint': 'https://api.workos.com/scim/v2.0/UNxMntQuAss69Pns/?aadOptscim062020',
        'token': 'se_WWwndlq80MmrxLfrz8bbOBfEN',
        'sync_type': 'staged',
        'live': true,
      });
    },
    saveChanges({ commit, rootState, dispatch, state }: any, obj: any) {
      let dateNow = new Date()
      let form = obj.form
      firebase.database().ref(`/integration_settings/${rootState.authen.user.company}`).update({
        token: form.token_temp ? form.token_temp : form.token,
        sync_type: form.sync_type,
        live: form.live,
        abbreviate_team_name: form.abbreviate_team_name,
        updated: format(dateNow, 'YYYY-MM-DD HH:mm')
      }).then(() => {
        dispatch('authen/addLogs', {
          company: rootState.authen.user.company,
          createdate: format(dateNow, 'YYYY-MM-DD HH:mm:ss'),
          id: rootState.authen.user.company,
          table: 'integration_settings',
          status: 'updateIntegrationSetting',
          user: rootState.authen.user.email
        }, { root: true })
      }).then(() => {
        obj.messageLoading.close();
        obj.thisvue.$message({
          type: 'success',
          message: 'Your settings have been updated',
        });
      })
    },
    async getSimulateData({ commit, rootState, dispatch, state }: any, obj: any) {
      commit('setLoadingSimulateTable', true)
      let allUser: Array<any> = [];
      let arrUser: Array<any> = [];
      state.membersSimulate = []
      state.membersSimulate = []
      let start_date = format(parse(obj.batch_ct), 'MMM d, YYYY')
      let start_date_format = format(parse(obj.batch_ct), 'YYYY-MM-DD')
      const allUserKey = rootState.main.allUser //(await firebase.database().ref('users').orderByChild("company").equalTo(obj.comp_id).once('value')).val()
      const team = (await firebase.database().ref('team').orderByChild("company").equalTo(obj.comp_id).once('value')).val()
      for(const arrData in rootState.main.allUser){
        const u =  rootState.main.allUser[arrData]
        u.key = arrData
        u.value = rootState.main.allUser[arrData].firstname + " " + rootState.main.allUser[arrData].lastname
        let k_boss = rootState.main.allUser[arrData].boss.replace(/\./g, "||")
        if (k_boss && allUserKey[k_boss] != undefined) {
          u.boss_name = allUserKey[k_boss]["firstname"] + " " + allUserKey[k_boss]["lastname"]
        }
        if (u.team) u.team_name = (team[u.team] != undefined) ? team[u.team]["name"] : ''
        if (u.profilepic_small) {
          u.pic = u.profilepic_small;
        } else if (u.profilepic_crop) {
          u.pic = u.profilepic_crop;
        } else if (u.profilepic) {
          u.pic = u.profilepic;
        } else {
          u.pic = "";
        }
        u.change_type = 'None'
        allUser[u.key] = u
      }
      await firebase.database().ref().child('users_preview').orderByChild('batch_ct').equalTo(`${obj.batch_ct}`).once('value', snapshot => {
        snapshot.forEach((arrData): any => {
          const u = arrData.val()
          if (u.company == obj.comp_id) {
            u.key = arrData.key
            u.value = arrData.val().firstname + " " + arrData.val().lastname
            let k_boss = arrData.val().boss.replace(/\./g, "||")
            if (k_boss && allUserKey[k_boss] != undefined) {
              u.boss_name = allUserKey[k_boss]["firstname"] + " " + allUserKey[k_boss]["lastname"]
            }
            u.team_name = (u.team != undefined) ? u.team : ''
            u.pic = (allUser[u.key] != undefined) ? allUser[u.key].pic : ''
            if (u.action_type == 'add') {
              u.change_type = 'New Member'
            } else if (u.action_type == 'update') {
              u.change_type = 'Profile Updated'
            } else if (u.action_type == 'delete') {
              u.change_type = 'Archived'
            }
            u.start_date = start_date
            u.start_date_format = start_date_format
            allUser[u.key] = u
          }
        });
        for (const x in allUser) {
          arrUser.push(allUser[x])
        }
        var _users = _.sortBy(arrUser, [function (o: any) { return o.firstname; }])
        commit('setResultsSimulate', arrUser)
        commit('setMemberSimulate', _.sortBy(_users.slice(0, state.size_page), [function (o: any) { return o.firstname; }]))
        commit('setMemberSimulateAll', _.sortBy(arrUser, [function (o: any) { return o.firstname; }]))
        commit('setLoadingSimulateTable', false)
        if (state.inputSearchSimulate) {
          dispatch('searchMembersSimulate', state.inputSearchSimulate)
        }
      });
      // await firebase.database().ref().child('users').orderByChild('company').equalTo(`${obj.comp_id}`).once('value', async snapshot => {
      //   snapshot.forEach((arrData): any => {
      //     const u = arrData.val()
      //     u.key = arrData.key
      //     u.value = arrData.val().firstname + " " + arrData.val().lastname
      //     let k_boss = arrData.val().boss.replace(/\./g, "||")
      //     if (k_boss && allUserKey[k_boss] != undefined) {
      //       u.boss_name = allUserKey[k_boss]["firstname"] + " " + allUserKey[k_boss]["lastname"]
      //     }
      //     if (u.team) u.team_name = (team[u.team] != undefined) ? team[u.team]["name"] : ''
      //     if (u.profilepic_small) {
      //       u.pic = u.profilepic_small;
      //     } else if (u.profilepic_crop) {
      //       u.pic = u.profilepic_crop;
      //     } else if (u.profilepic) {
      //       u.pic = u.profilepic;
      //     } else {
      //       u.pic = "";
      //     }
      //     u.change_type = 'None'
      //     allUser[u.key] = u
      //   });
      //   await firebase.database().ref().child('users_preview').orderByChild('batch_ct').equalTo(`${obj.batch_ct}`).once('value', snapshot => {
      //     snapshot.forEach((arrData): any => {
      //       const u = arrData.val()
      //       if (u.company == obj.comp_id) {
      //         u.key = arrData.key
      //         u.value = arrData.val().firstname + " " + arrData.val().lastname
      //         let k_boss = arrData.val().boss.replace(/\./g, "||")
      //         if (k_boss && allUserKey[k_boss] != undefined) {
      //           u.boss_name = allUserKey[k_boss]["firstname"] + " " + allUserKey[k_boss]["lastname"]
      //         }
      //         u.team_name = (u.team != undefined) ? u.team : ''
      //         u.pic = (allUser[u.key] != undefined) ? allUser[u.key].pic : ''
      //         if (u.action_type == 'add') {
      //           u.change_type = 'New Member'
      //         } else if (u.action_type == 'update') {
      //           u.change_type = 'Profile Updated'
      //         } else if (u.action_type == 'delete') {
      //           u.change_type = 'Archived'
      //         }
      //         u.start_date = start_date
      //         u.start_date_format = start_date_format
      //         allUser[u.key] = u
      //       }
      //     });
      //     for (const x in allUser) {
      //       arrUser.push(allUser[x])
      //     }
      //     var _users = _.sortBy(arrUser, [function (o: any) { return o.firstname; }])
      //     commit('setResultsSimulate', arrUser)
      //     commit('setMemberSimulate', _.sortBy(_users.slice(0, state.size_page), [function (o: any) { return o.firstname; }]))
      //     commit('setMemberSimulateAll', _.sortBy(arrUser, [function (o: any) { return o.firstname; }]))
      //     commit('setLoadingSimulateTable', false)
      //     if (state.inputSearchSimulate) {
      //       dispatch('searchMembersSimulate', state.inputSearchSimulate)
      //     }
      //   });
      // }).catch(error => {
      //   console.log(error)
      // });
    },
    searchMembersSimulate({ commit, state }: any, value: string) {
      let field = state.sortfieldsimulate
      let order = state.sortordersimulate
      commit('setPageSimulate', 1)
      const member: Array<any> = [];
      member.push(state.membersSimulateAll)

      if (field == 'name')
        field = 'value'

      if (order == 'ascending' || order == 'asc')
        order = 'asc'
      else
        order = 'desc'

      if (value.length > 2) {
        if (member.length > 0) {
          var re = new RegExp(value, 'gi')
          var response = _.filter(member[0], (item): any => {
            if (item.firstname.match(re)) {
              return true
            } else if (item.lastname != undefined && item.lastname.match(re)) {
              return true
            } else if (item.email != undefined && item.email.match(re)) {
              return true
            } else if (item.team_name != undefined && item.team_name.match(re)) {
              return true
            }
          });
          let response_sort = _.orderBy(response, [field], [order]);
          commit('setResultsSimulate', response_sort)
          commit('setMemberSimulate', response_sort.slice(0, state.size_page))
        }
      } else if (value.length == 0) {
        let response_sort = _.orderBy(member[0], [field], [order]);
        commit('setResultsSimulate', response_sort)
        commit('setMemberSimulate', response_sort.slice(0, state.size_page))
      }
    },
    sortMemberSimulate({ commit, state }: any, value: any) {
      var member: Array<any> = [];
      member.push(state.membersSimulateAll)
      if (state.inputSearchSimulate.length > 2) {
        if (member.length > 0) {
          var re = new RegExp(state.inputSearchSimulate, 'gi')
          var response = _.filter(member[0], (item): any => {
            if (item.firstname.match(re)) {
              return true
            } else if (item.lastname != undefined && item.lastname.match(re)) {
              return true
            } else if (item.email != undefined && item.email.match(re)) {
              return true
            } else if (item.team_name != undefined && item.team_name.match(re)) {
              return true
            }
          });
          member = []
          member.push(response)
        }
      }

      var size = state.size_page
      var page = state.pagesimulate
      var field = value[0]
      var order = value[1]
      var start_row = (page - 1) * size
      var end_row = ((page - 1) * size) + size

      if (field == 'name')
        field = 'value'

      if (order == 'ascending' || order == 'asc') {
        order = 'asc'
      } else {
        order = 'desc'
      }
      var _users = _.orderBy(member[0], [field], [order]);
      commit('setSortfieldSimulate', field)
      commit('setSortorderSimulate', order)
      commit('setMemberSimulate', _users.slice(start_row, end_row))
    },
    simulateCurrentChange({ commit, state }: any, page: any) {
      var size = state.size_page
      var start_row = (page - 1) * size
      var end_row = ((page - 1) * size) + size
      let member: Array<any> = [];
      member.push(state.membersSimulateAll)
      if (state.inputSearchSimulate.length > 2) {
        if (member.length > 0) {
          var re = new RegExp(state.inputSearchSimulate, 'gi')
          var response = _.filter(member[0], (item): any => {
            if (item.firstname.match(re)) {
              return true
            } else if (item.lastname != undefined && item.lastname.match(re)) {
              return true
            } else if (item.email != undefined && item.email.match(re)) {
              return true
            } else if (item.team_name != undefined && item.team_name.match(re)) {
              return true
            }
          });
          member[0] = response
        }
      }

      var field = state.sortfieldsimulate
      var _users = _.orderBy(member[0], [field], [state.sortordersimulate]);
      commit('setPageSimulate', page)
      commit('setMemberSimulate', _users.slice(start_row, end_row))
    },
    async getViewData({ commit, rootState, dispatch, state }: any, obj: any) {
      commit('setLoadingViewTable', true)
      let allUser: Array<any> = [];
      let arrUser: Array<any> = [];
      state.membersView = []
      state.membersView = []
      let start_date = format(parse(obj.batch_ct), 'MMM d, YYYY')
      let start_date_format = format(parse(obj.batch_ct), 'YYYY-MM-DD')
      const allUserKey = rootState.main.allUser//(await firebase.database().ref('users').orderByChild("company").equalTo(obj.comp_id).once('value')).val()
      const team = (await firebase.database().ref('team').orderByChild("company").equalTo(obj.comp_id).once('value')).val()
      await firebase.database().ref().child('integration_changelogs').orderByChild('batch_ct').equalTo(`${obj.batch_ct}`).once('value', snapshot => {
        snapshot.forEach((arrData): any => {
          const u = arrData.val()
          if (u.comp_id == obj.comp_id) {
            if (u.change_logs.length > 0) {
              _.forEach(u.change_logs, (item, key) => {
                let dataUser = item
                dataUser.key = dataUser.email.replace(/\./g, "||")
                dataUser.value = dataUser.firstname + " " + dataUser.lastname
                let k_boss = dataUser.boss.replace(/\./g, "||")
                if (k_boss && allUserKey[k_boss] != undefined) {
                  dataUser.boss_name = allUserKey[k_boss]["firstname"] + " " + allUserKey[k_boss]["lastname"]
                }
                dataUser.team_name = (dataUser.team != undefined) ? dataUser.team : ''
                if (allUserKey[dataUser.key] != undefined) {
                  if (allUserKey[dataUser.key].profilepic_small) {
                    dataUser.pic = allUserKey[dataUser.key].profilepic_small;
                  } else if (allUserKey[dataUser.key].profilepic_crop) {
                    dataUser.pic = allUserKey[dataUser.key].profilepic_crop;
                  } else if (allUserKey[dataUser.key].profilepic) {
                    dataUser.pic = allUserKey[dataUser.key].profilepic;
                  } else {
                    dataUser.pic = "";
                  }
                } else {
                  dataUser.pic = "";
                }

                if (dataUser.action_type == 'add') {
                  dataUser.change_type = 'New Member'
                } else if (dataUser.action_type == 'update') {
                  dataUser.change_type = 'Profile Updated'
                } else if (dataUser.action_type == 'delete') {
                  dataUser.change_type = 'Archived'
                }
                dataUser.start_date = start_date
                dataUser.start_date_format = start_date_format
                arrUser.push(dataUser)
              });
            }
          }
        });
        var _users = _.sortBy(arrUser, [function (o: any) { return o.firstname; }])
        commit('setResultsView', arrUser)
        commit('setMemberView', _.sortBy(_users.slice(0, state.size_page), [function (o: any) { return o.firstname; }]))
        commit('setMemberViewAll', _.sortBy(arrUser, [function (o: any) { return o.firstname; }]))
        commit('setLoadingViewTable', false)
        if (state.inputSearchView) {
          dispatch('searchMembersView', state.inputSearchview)
        }
      });
    },
    searchMembersView({ commit, state }: any, value: string) {
      let field = state.sortfieldview
      let order = state.sortorderview
      commit('setPageView', 1)
      const member: Array<any> = [];
      member.push(state.membersViewAll)

      if (field == 'name')
        field = 'value'

      if (order == 'ascending' || order == 'asc')
        order = 'asc'
      else
        order = 'desc'

      if (value.length > 2) {
        if (member.length > 0) {
          var re = new RegExp(value, 'gi')
          var response = _.filter(member[0], (item): any => {
            if (item.firstname.match(re)) {
              return true
            } else if (item.lastname != undefined && item.lastname.match(re)) {
              return true
            } else if (item.email != undefined && item.email.match(re)) {
              return true
            } else if (item.team_name != undefined && item.team_name.match(re)) {
              return true
            }
          });
          let response_sort = _.orderBy(response, [field], [order]);
          commit('setResultsView', response_sort)
          commit('setMemberView', response_sort.slice(0, state.size_page))
        }
      } else if (value.length == 0) {
        let response_sort = _.orderBy(member[0], [field], [order]);
        commit('setResultsView', response_sort)
        commit('setMemberView', response_sort.slice(0, state.size_page))
      }
    },
    sortMemberView({ commit, state }: any, value: any) {
      var member: Array<any> = [];
      member.push(state.membersViewAll)
      if (state.inputSearchView.length > 2) {
        if (member.length > 0) {
          var re = new RegExp(state.inputSearchView, 'gi')
          var response = _.filter(member[0], (item): any => {
            if (item.firstname.match(re)) {
              return true
            } else if (item.lastname != undefined && item.lastname.match(re)) {
              return true
            } else if (item.email != undefined && item.email.match(re)) {
              return true
            } else if (item.team_name != undefined && item.team_name.match(re)) {
              return true
            }
          });
          member = []
          member.push(response)
        }
      }

      var size = state.size_page
      var page = state.pageview
      var field = value[0]
      var order = value[1]
      var start_row = (page - 1) * size
      var end_row = ((page - 1) * size) + size

      if (field == 'name')
        field = 'value'

      if (order == 'ascending' || order == 'asc') {
        order = 'asc'
      } else {
        order = 'desc'
      }
      var _users = _.orderBy(member[0], [field], [order]);
      commit('setSortfieldView', field)
      commit('setSortorderView', order)
      commit('setMemberView', _users.slice(start_row, end_row))
    },
    viewCurrentChange({ commit, state }: any, page: any) {
      var size = state.size_page
      var start_row = (page - 1) * size
      var end_row = ((page - 1) * size) + size
      let member: Array<any> = [];
      member.push(state.membersViewAll)
      if (state.inputSearchView.length > 2) {
        if (member.length > 0) {
          var re = new RegExp(state.inputSearchView, 'gi')
          var response = _.filter(member[0], (item): any => {
            if (item.firstname.match(re)) {
              return true
            } else if (item.lastname != undefined && item.lastname.match(re)) {
              return true
            } else if (item.email != undefined && item.email.match(re)) {
              return true
            } else if (item.team_name != undefined && item.team_name.match(re)) {
              return true
            }
          });
          member[0] = response
        }
      }

      var field = state.sortfieldview
      var _users = _.orderBy(member[0], [field], [state.sortorderview]);
      commit('setPageView', page)
      commit('setMemberView', _users.slice(start_row, end_row))
    },

    async getReviewUpdatesTotal({commit,rootState,dispatch,state}:any, user:any){
      let query = firebase.firestore()
        .collection('integrations')
        .where('company','==', user.company);
      
      if (!state.reviewUpdatesIgnorePendingStatus) {
        query = query.where('status','==', 'pending')
      }

      await query.get()
        .then((querySnapshot)=> {
          commit('setReviewUpdatesTotal', querySnapshot.size);
        });
    },

    beginBulkUpdates({ commit, rootState, dispatch, state }: any, keys: string[]) {
      commit("setReviewUpdatesLoading", true);
      state._reviewUpdates = state.reviewUpdates;
      state._reviewUpdatesAll = state.reviewUpdatesAll;
      commit("setReviewUpdates", []);
      commit("setReviewUpdatesAll", []);
    },

    endBulkUpdates({ commit, rootState, dispatch, state }: any, keys: []) {
      commit("setReviewUpdatesLoading", false);

      const reviewUpdates = _.cloneDeep(state._reviewUpdates);
      const reviewUpdatesAll = _.cloneDeep(state._reviewUpdatesAll);

      for (const i in keys) {
        _.remove(reviewUpdates, {key: keys[i]});
        _.remove(reviewUpdatesAll, {key: keys[i]});
      }

      commit("setReviewUpdates", reviewUpdates);
      commit("setReviewUpdatesAll", reviewUpdatesAll);

      // @todo pagination
      // const items = _.cloneDeep(state.reviewUpdates);
      const items = state.reviewUpdates;
      const size = state.size_page
      const page = state.pageReviewUpdates
      const start_row = (page-1) * size
      const end_row = ((page-1) * size)+size

      const pageTotal = reviewUpdatesAll.length;

      const newPage = Math.ceil((pageTotal -1) / size)

      // update current items in table view
      const realItems = reviewUpdatesAll.slice(start_row,end_row)
      if (realItems.length > items.length) {
        items.push(realItems[items.length -1]);
      }

      // update pagination
      // state.reviewUpdates = items;
      state.reviewUpdates = _.clone(items); // prevent non-update on view
      if (newPage < page) {
        commit('setPageReviewUpdates', newPage)
      }

      // update page total
      commit('setReviewUpdatesTotal', pageTotal);
    },

    async updateReviewUpdates({commit,rootState,dispatch,state}:any, item:any){
      // console.log('updateReviewUpdates()');
      // console.log(item, "item");

      // firebase.firestore().collection('townhall').doc(topic_id).update(topic).then(() => {
      await firebase.firestore().collection(`integrations`).doc(item.key).get().then(async (doc) => {    
        await firebase.firestore().collection('integrations').doc(item.key).update({ status: item.status }).then(() => {
          // console.log('remove item: ' + item.key);

          /*

          _.remove(state.reviewUpdates, {key: item.key});
          _.remove(state.reviewUpdatesAll, {key: item.key});

          // const items = _.cloneDeep(state.reviewUpdates);
          const items = state.reviewUpdates;
          const size = state.size_page
          const page = state.pageReviewUpdates
          const start_row = (page-1) * size
          const end_row = ((page-1) * size)+size

          const pageTotal = state.reviewUpdatesAll.length;

          const newPage = Math.ceil((pageTotal -1) / size)

          // update current items in table view
          const realItems = state.reviewUpdatesAll.slice(start_row,end_row)
          if (realItems.length > items.length) {
            items.push(realItems[items.length -1]);
          }

          // update pagination
          // state.reviewUpdates = items;
          state.reviewUpdates = _.clone(items); // prevent non-update on view
          if (newPage < page) {
            commit('setPageReviewUpdates', newPage)
          }

          // update page total
          commit('setReviewUpdatesTotal', pageTotal);

          //*/
        });
      });
    },
    async getReviewUpdates({commit,rootState,dispatch,state}:any, user:any){
      commit('setReviewUpdatesLoading', true)
      state.reviewUpdates = []
      state.reviewUpdatesAll = []

      let items: Array<any> = [];
      const reviewUpdatesByKey :Array<any> = [];

      // @todo use from another
      const company = (await firebase.database().ref(`company/${user.company}`).once('value')).val();
      const allUser =(await firebase.database().ref('users').orderByChild("company").equalTo(user.company).once('value')).val();
      // console.log(allUser, "allUser");
      const teamByKey = rootState.newmember.teamByKey;

      // const $utils = Vue.prototype.$utilities;

      let query = firebase.firestore()
        .collection('integrations')
        .where('company','==', user.company);

      if (!state.reviewUpdatesIgnorePendingStatus) {
        query = query.where('status','==', 'pending')
      }

      await query
        // .orderBy('createdate', 'desc') // affected to pagination when press next page
        .get()
        .then((querySnapshot)=> {
            querySnapshot.forEach((doc)=> {
              // console.log(doc.id, " => ", doc.data());
              let data = doc.data();

              // @todo fields: pic, firstname, lastname
              const email =  _.get(data, "email", "");
              const emailkey = email.replace(/\./g, "||");

              const applyUserInfo = (email) => {
                const emailkey = email.replace(/\./g, "||");
                data.firstname = _.get(allUser, `${emailkey}.firstname`, "");
                data.lastname = _.get(allUser, `${emailkey}.lastname`, "");
                data.name = `${data.firstname} ${data.lastname} ${email}`;
              }

              const applyRequestedBy = (email) => {
                if (!email) return;
                const emailkey = email.replace(/\./g, "||");
                const firstname = _.get(allUser, `${emailkey}.firstname`, "");
                const lastname = _.get(allUser, `${emailkey}.lastname`, "");
                data.requested_by = `${firstname} ${lastname.length ? lastname[0] : ""}`;
              }

              if (!_.get(data, "firstname") || !_.get(data, "lastname")) {
                applyUserInfo(email);
              }

              data.key = doc.id;

              // important data for edit in table
              data.name = `${data.firstname} ${data.lastname} ${data.email}`;
              data.manager = "";
              data.country = _.get(company, "country", "TH");
              data.language = data.country == "TH" ? "th" : "en";
              data.archived_type = "";

              // for read only input
              data.manager_name = "";
              data.team_name = "";

              let managerOption = null;
              if (data.source == "app") {
                // @fixed data mapping and getting requirements
                if (data.type == "direct_manager") {
                  const _email = _.get(data, "email", "");
                  const _email_request = _.get(data, "email_request", "");
                  data.email = _email_request;
                  data.manager = _email;

                  const bossKey = data.manager.replace(/\./g, "||");
                  const bossInfo = _.get(allUser, `${bossKey}`, {});
                  data.team = _.get(bossInfo, "team", "");

                  applyUserInfo(data.email);
                  applyRequestedBy(_email_request);
                } else if (data.type == "re_assign") {
                  const _email_request = _.get(data, "email_request", "");
                  data.team = "";
                  applyUserInfo(data.email);
                  applyRequestedBy(_email_request);
                } else if (data.type == "add_member") {
                  const _email_request = _.get(data, "email_request", "");
                  data.manager = _email_request;
                  applyRequestedBy(_email_request);
                } else if (data.type == "remove") {
                  applyUserInfo(data.email);
                  applyRequestedBy(data.email_request);

                  // team_name, manager_name, requested_by
                  const userInfo = _.get(allUser, emailkey, {});
                  data.team = _.get(userInfo, "team", "");
                  data.manager = _.get(userInfo, "boss", "");
                }

              } else if (data.source == "hris") {
                if (_.has(data, "direct_manager_email")) {
                  data.manager = _.get(data, "direct_manager_email", "");
                }
                if (_.has(data, "team")) {
                  data.team = _.get(data, "team", "");
                }
                if (data.type == "delete") {
                  data.manager = _.get(allUser, `${emailkey}.boss`, "");
                  data.team = _.get(allUser, `${emailkey}.team`, "");
                }
              }

              if (!_.has(data, "team")) {
                data.team = "";
              }

              if (data.manager) {
                managerOption = _.find(allUser, {email: data.manager});
                data.manager_name = managerOption ? 
                  `${_.get(managerOption, "firstname", "")} ${_.get(managerOption, "lastname", "")}`: 
                  data.manager;
              }

              if (data.team) {
                data.team_name = _.has(teamByKey, data.team) ?
                  _.get(teamByKey, `${data.team}.name`, "") :
                  data.team;
              }

              // resolve default manager label
              /*
              if (data.manager) {
                const managerIndex = _.findIndex(managerOptions, function(o) { return o.email == data.manager; });
                // console.log(data.manager, managerIndex);
                data.manager = managerIndex;
              }
              //*/
              

              items.push(data);
              reviewUpdatesByKey[doc.id] = data;
            })
          });

      commit('setReviewUpdatesByKey', reviewUpdatesByKey);
      commit('setReviewUpdatesAll', _.clone(items));
      commit('setReviewUpdatesTotal', items.length);
      items = _.sortBy(items.slice(0, state.size_page), [function(o:any) { return o.email; }]);

      commit('setPageReviewUpdates', 1);
      commit('setReviewUpdates', items);

      commit('setReviewUpdatesLoading', false);
    },
    sortReviewUpdates({commit,state}:any,value:any){
      //*
      var member: Array<any> = [];
      member.push(state.reviewUpdatesAll)
      /*
      if (state.inputSearchArchive.length > 2){
        if (member.length > 0){
          var re = new RegExp(state.inputSearchArchive, 'gi')
          var response = _.filter(member[0], (item): any => {
            if (item.firstname.match(re)) {
              return true
            } else if (item.lastname != undefined && item.lastname.match(re)) {
              return true
            } else if (item.value != undefined && (item.value.match(re))) {
              return true
            } else if (item.email != undefined && item.email.match(re)) {
              return true
            } else if (item.team_name != undefined && item.team_name.match(re)) {
              return true
            } else if (item.boss_firstname != undefined && item.boss_firstname.match(re)) {
              return true
            } else if (item.boss_lastname != undefined && item.boss_lastname.match(re)) {
              return true
            } else if (item.boss_name != undefined && item.boss_name.match(re)) {
              return true
            }
          });
          member = []
          member.push(response)
        }
      }
      //*/

      var size = state.size_page
      var page = state.pageReviewUpdates
      var field  = value[0]
      var order = value[1]
      var start_row = (page-1) * size
      var end_row = ((page-1) * size)+size

      // if(field == 'name')
      //   field = 'value'

      if(order == 'ascending' || order == 'asc'){
        if(field == 'exitdated'){
          order = 'desc'
        }else {
          order = 'asc'
        }
      }else {
        if(field == 'exitdated'){
          order = 'asc'
        }else{
          order = 'desc'
        }
      }
      var _users = _.orderBy(member[0], [field], [order]);
      commit('setSortfieldReviewUpdates', field)
      commit('setSortorderReviewUpdates', order)
      commit('setReviewUpdates', _users.slice(start_row,end_row))
      //*/
    },
    reviewUpdatesCurrentChange({commit,state}:any,page:any){
      var size = state.size_page
      var start_row = (page-1) * size
      var end_row = ((page-1) * size)+size
      let member: Array<any> = [];
      member.push(state.reviewUpdatesAll)
      // if (state.inputSearchArchive.length > 2){
      //   if (member.length > 0){
      //     var re = new RegExp(state.inputSearchArchive, 'gi')
      //     var response = _.filter(member[0], (item): any => {
      //       if (item.firstname.match(re)) {
      //         return true
      //       } else if (item.lastname != undefined && item.lastname.match(re)) {
      //         return true
      //       } else if (item.value != undefined && (item.value.match(re))) {
      //         return true
      //       } else if (item.email != undefined && item.email.match(re)) {
      //         return true
      //       } else if (item.team_name != undefined && item.team_name.match(re)) {
      //         return true
      //       } else if (item.boss_firstname != undefined && item.boss_firstname.match(re)) {
      //         return true
      //       } else if (item.boss_lastname != undefined && item.boss_lastname.match(re)) {
      //         return true
      //       } else if (item.boss_name != undefined && item.boss_name.match(re)) {
      //         return true
      //       }
      //     });
      //     member[0] = response
      //   }
      // }
      
      var field = state.sortfieldreviewupdates
      var _users = _.orderBy(member[0], [field], [state.sortorderreviewupdates]);
      commit('setPageReviewUpdates', page)
      commit('setReviewUpdates', _users.slice(start_row, end_row))
    },
  },
  getters: {
    ssoEnabled: (state: any) => {
      return state.ssoEnabled
    },
    selectedSso: (state: any) => {
      return state.selectedSso
    },

    apiKeys: (state: any) => {
      return state.apiKeys
    },
    apiKeyDev: (state: any) => {
      return state.apiKeyDev
    },
    apiKeyProd: (state: any) => {
      return state.apiKeyProd
    },
    apiLogs: (state: any) => {
      return state.apiLogs
    },
    dataSettings: (state: any) => {
      return state.dataSettings
    },
    hasDirectorySyncSettings: (state: any) => {
      return state.hasDirectorySyncSettings
    },
    directorySyncSettings: (state: any) => {
      return state.directorySyncSettings
    },
    resultsSimulate: (state: any) => {
      return state.resultsSimulate
    },
    membersSimulate: (state: any) => {
      return state.membersSimulate
    },
    membersSimulateAll: (state: any) => {
      return state.membersSimulateAll
    },
    pagesimulate: (state: any) => {
      return state.pagesimulate
    },
    inputSearchSimulate: (state: any) => {
      return state.inputSearchSimulate
    },
    loadingSimulateTable: (state: any) => {
      return state.loadingSimulateTable
    },
    resultsView: (state: any) => {
      return state.resultsView
    },
    membersView: (state: any) => {
      return state.membersView
    },
    membersViewAll: (state: any) => {
      return state.membersViewAll
    },
    pageview: (state: any) => {
      return state.pageview
    },
    inputSearchView: (state: any) => {
      return state.inputSearchView
    },
    loadingViewTable: (state: any) => {
      return state.loadingViewTable
    },
    reviewUpdates: (state: any) => {
      return state.reviewUpdates
    },
    reviewUpdatesAll: (state: any) => {
      return state.reviewUpdatesAll
    },
    reviewUpdatesLoading: (state: any) => {
      return state.reviewUpdatesLoading
    },
    reviewUpdatesTotal: (state: any) => {
      return state.reviewUpdatesTotal
    },
    reviewUpdatesPage: (state: any) => {
      return state.reviewUpdatesPage
    },
    reviewUpdatesByKey: (state: any) => {
      return state.reviewUpdatesByKey
    },
    pageReviewUpdates: (state: any) => {
      return state.pageReviewUpdates
    },
    reviewUpdatesIgnorePendingStatus: (state: any) => {
      return state.pageReviewUpdates
    }
  }
}